<div class="header">
  <h1>{{ title }}</h1>
  <button class="close-button" (click)="dismiss()">
    <img src="./assets/svgs/close_outline.svg" />
  </button>
</div>
<ng-content></ng-content>
